// services/trainingApi.js
import api from "./api";

// ── Videos ───────────────────────────────────────────────────
export function getVideos() {
  return api.get("/training/videos");
}

export function registerVideo(filename) {
  return api.post("/training/videos", { filename });
}

export function uploadVideo(formData, onUploadProgress) {
  return api.post("/training/videos", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress,
  });
}

export function processVideo(videoId, fps) {
  return api.post("/training/videos/process", { videoId, fps });
}

export function updateVideo(videoId, payload) {
  return api.put(`/training/videos/${videoId}`, payload);
}

export function deleteVideo(videoId) {
  return api.delete(`/training/videos/${videoId}`);
}

// ── Frames & Labels ──────────────────────────────────────────
export function getFrames(params = {}) {
  return api.get("/training/frames", { params });
}

export function exportLabels(splitRatio = 0.8) {
  return api.post("/training/export", { splitRatio });
}

// ── Training ─────────────────────────────────────────────────
export function getTrainingStatus() {
  return api.get("/training/train");
}

export function startTraining(params) {
  return api.post("/training/train", params);
}

export function stopTraining() {
  return api.delete("/training/train");
}

// ── Test ─────────────────────────────────────────────────────
export function runTest(params) {
  return api.post("/training/test", params);
}

export function getTestImageUrl(filename) {
  return `${api.defaults.baseURL}/training/test/image/${filename}`;
}